// components/CreatorFi.js
import React, { useState, useEffect, useRef } from 'react';
import './CreatorFi.css';

const CreatorFi = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const videoRefs = useRef([]);
  const carouselRef = useRef(null);

  const videos = [
    {
      src: "https://creatorbuzz-public-bucket.s3.ap-southeast-1.amazonaws.com/videos/task-creation.mp4",
      title: "Task Creation",
      description: "Streamlined task creation and assignment for influencer campaigns"
    },
    {
      src: "https://creatorbuzz-public-bucket.s3.ap-southeast-1.amazonaws.com/videos/creator-discovery-hub.mp4",
      title: "Creator Discovery",
      description: "Advanced creator discovery and matching algorithms"
    },
    {
      src: "https://creatorbuzz-public-bucket.s3.ap-southeast-1.amazonaws.com/videos/campaign-management.mp4",
      title: "Campaign Management",
      description: "End-to-end campaign management and workflow automation"
    },
    {
      src: "https://creatorbuzz-public-bucket.s3.ap-southeast-1.amazonaws.com/videos/campaign-analytics.mp4",
      title: "Campaign Analytics",
      description: "Real-time analytics and performance tracking"
    }
  ];

  // Auto-play carousel
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % videos.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, videos.length]);

  // Pause videos when not active
  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === currentSlide) {
          video.play().catch(console.error);
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % videos.length);
    setIsAutoPlaying(false);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + videos.length) % videos.length);
    setIsAutoPlaying(false);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
  };

  const setVideoRef = (index) => (el) => {
    videoRefs.current[index] = el;
  };

  return (
    <section id="creatorfi" className="services-experimental creatorfi-section">
      <div className="container">
        <div className="section-header-experimental">
          <div className="header-decoration">
            <div className="decoration-line" />
            <h2>Our Product</h2>
            <div className="decoration-line" />
          </div>
          <p>GamingGrid runs exclusively on CreatorFi, leveraging its powerful suite to manage every aspect of our creator campaigns.</p>
        </div>

        {/* Video Carousel */}
        <div className="creatorfi-carousel" ref={carouselRef}>
          {/* Main Carousel Container */}
          <div className="carousel-container">
            {/* Navigation Arrows */}
            <button className="carousel-arrow carousel-arrow-prev" onClick={prevSlide}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
            </button>

            <button className="carousel-arrow carousel-arrow-next" onClick={nextSlide}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </button>

            {/* Video Slides */}
            <div className="carousel-track">
              {videos.map((video, index) => (
                <div
                  key={index}
                  className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                >
                  <div className="video-card">
                    {/* Corner Borders */}
                    <div className="card-corner top-left"></div>
                    <div className="card-corner top-right"></div>
                    <div className="card-corner bottom-left"></div>
                    <div className="card-corner bottom-right"></div>

                    {/* Video Container */}
                    <div className="video-container">
                      <video
                        ref={setVideoRef(index)}
                        src={video.src}
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        className="carousel-video"
                      />
                      <div className="video-overlay">
                        <div className="play-indicator">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8 5v14l11-7z"/>
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* Video Info */}
                    <div className="video-info">
                      <h3>{video.title}</h3>
                      <div className="title-underline" />
                      <p>{video.description}</p>
                    </div>

                    <div className="service-number">0{index + 1}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Carousel Indicators */}
          <div className="carousel-indicators">
            {videos.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              >
                <span className="indicator-progress"></span>
              </button>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="creatorfi-cta">
          <div className="cta-content">
            <h3>Ready to Transform Your Influencer Campaigns?</h3>
            <p>Experience the power of CreatorFi for yourself</p>
            <a 
              href="https://creatorfi.io" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="creatorfi-button"
            >
              Visit CreatorFi.io
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreatorFi;